<!-- src/components/Layout/QuickBugButton.vue -->
<template>
  <template v-if="shouldRender">
    <button
      type="button"
      data-bug-capture-hide="true"
      class="inline-flex items-center gap-1.5 rounded-full border border-brand-dark-blue/20 bg-white/90 px-3 py-1.5 text-xs font-medium text-brand-dark-blue shadow-sm transition hover:border-brand-dark-blue/40 hover:bg-white hover:shadow-md focus:outline-none focus:ring-2 focus:ring-brand-blue/40"
      title="Report a bug — captures screenshot, recent activity, and console logs"
      @click="open"
    >
      <Bug class="icon-xs" />
      <span class="hidden sm:inline">Report Bug</span>
    </button>

    <Teleport to="body">
      <QuickBugModal
        v-if="showModal"
        data-bug-capture-hide="true"
        @close="showModal = false"
        @submitted="onSubmitted"
      />
    </Teleport>
  </template>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { Bug } from 'lucide-vue-next'
import { useUserStore } from '@/stores/userStore'
import { useFrontendFlagsStore } from '@/stores/frontendFlagsStore'
import QuickBugModal from '@/components/BugReports/QuickBugModal.vue'

const router = useRouter()
const userStore = useUserStore()
const flagsStore = useFrontendFlagsStore()

const showModal = ref(false)

// Only show once we have a signed-in internal user and the module is enabled.
// Customer-role users stay on the consumer portal — they don't see this button.
const shouldRender = computed(() => {
  if (!flagsStore.isModuleEnabled('bugReports')) return false
  if (!userStore.user || !userStore.isInitialized) return false
  if (userStore.isCustomer && !userStore.isAdmin && !userStore.isSuperAdmin) return false
  return true
})

function open() {
  showModal.value = true
}

function onSubmitted(bugReportId) {
  showModal.value = false
  if (bugReportId) {
    router.push({ name: 'BugReports', query: { id: bugReportId } }).catch(() => {})
  }
}
</script>
